import PropTypes from 'prop-types';
import React from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import SelectStyled from './SelectStyled';

const SelectControl = ({
  label,
  customClass,
  enableFullWidth,
  caption,
  data,
  isInvalid,
  errorMessage,
  onChange,
  disabled,
  name,
  onClick,
  tooltip = '',
}) => {
  const renderLabel = () => {
    if (!label) {
      return null;
    }

    return (
      <label className="form-label" htmlFor={name}>
        {label}
      </label>
    );
  };

  return (
    <SelectStyled disabled={disabled}>
      <div className="nativeSelect">
        <Form.Group>
          <FloatingLabel controlId={name} label={renderLabel()}>
            <Form.Select
              className={`form-control ${customClass} ${enableFullWidth && 'fullWidth'}`}
              isInvalid={isInvalid}
              onChange={onChange}
              value={caption}
              disabled={disabled}
              name={name}
              onClick={onClick}
              title={tooltip}
            >
              {caption && (
                <option key="blankChoice" hidden value>
                  {caption}
                </option>
              )}
              {data?.length !== 0 ? (
                data?.map((item, i) => (
                  <option key={`${i + (item?.value ?? '')}`} value={item?.text}>
                    {item?.text}
                  </option>
                ))
              ) : (
                <option value="0">No Data</option>
              )}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </div>
    </SelectStyled>
  );
};

SelectControl.propTypes = {
  label: PropTypes.string,
  customClass: PropTypes.string,
  enableFullWidth: PropTypes.bool,
  caption: PropTypes.string,
  data: PropTypes.array,
  isInvalid: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  tooltip: PropTypes.string,
};

SelectControl.defaultProps = {
  label: '',
  customClass: '',
  enableFullWidth: false,
  caption: 'Select',
  data: [],
  isInvalid: false,
  errorMessage: '',
  onChange: () => {},
  onClick: () => {},
  disabled: false,
  name: '',
  tooltip: '',
};

export default SelectControl;
